import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AppLayout } from "@/components/AppLayout";
import { toast } from "sonner";
import { MapPin, SlidersHorizontal } from "lucide-react";

export default function ModulesAdmin() {
  const [modules, setModules] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api("/admin/modules").then(setModules).catch((e) => toast.error(e.message));
  }, []);

  const toggle = async (key) => {
    const next = { ...modules, [key]: !modules[key] };
    setModules(next);
    setSaving(true);
    try {
      const res = await api("/admin/modules", { method: "PUT", body: next });
      setModules(res);
      toast.success("Modules mis à jour");
    } catch (e) {
      toast.error(e.message);
      setModules(modules);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AppLayout variant="admin">
      <div data-testid="modules-admin" className="space-y-6 animate-fade-in max-w-2xl">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="h-6 w-6 text-cfhtb-primary" />
          <h1 className="font-serif text-3xl font-bold text-cfhtb-heading tracking-tight">Modules</h1>
        </div>
        <p className="text-sm text-cfhtb-text">
          Activez ou masquez des fonctionnalités de l'espace adhérent.
        </p>

        {!modules ? (
          <div className="h-8 w-8 border-2 border-cfhtb-primary border-t-transparent rounded-full animate-spin" />
        ) : (
          <div className="bg-white rounded-lg border border-cfhtb-light/30 shadow-sm divide-y divide-slate-100">
            <div className="flex items-center justify-between gap-4 p-5">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-cfhtb-secondary mt-0.5" />
                <div>
                  <p className="font-medium text-cfhtb-heading text-sm">Annuaire des praticiens</p>
                  <p className="text-xs text-cfhtb-text mt-0.5">
                    Affiche l'onglet « Annuaire » et la carte dans l'espace adhérent.
                  </p>
                </div>
              </div>
              <button
                type="button"
                data-testid="toggle-annuaire"
                disabled={saving}
                onClick={() => toggle("annuaire_visible")}
                className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${
                  modules.annuaire_visible ? "bg-cfhtb-primary" : "bg-slate-300"
                }`}
                aria-pressed={modules.annuaire_visible}
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                    modules.annuaire_visible ? "translate-x-5" : "translate-x-0.5"
                  }`}
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
